


















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { SelectItem } from '../select/types';

import './input-suggestions.scss';
import '@/assets/css/components/select-custom.scss';

@Component
export default class InputSuggestionsComponent extends Vue {
    @Prop() readonly data!: Record<string, any>;

    isShowHints = false;

    showHints() {
        this.isShowHints = true;
    }

    documentClick(e: Event) {
        const el = this.$refs.dropdownSearch as HTMLElement;
        const target = e.target as HTMLElement;

        if (this.isShowHints === true) {
            if (el !== target && !el.contains(target)) {
                this.isShowHints = false;
                this.$emit('focusout', this.data.value);
            }
        }
    }

    updateSearch(e: Event) {
        const value = (e.target as HTMLInputElement).value;
        this.isShowHints = true;
        this.$emit('input', value);

        if (!value) {
            this.$emit('click', { id: 0, value: '' });
        }
    }

    selectValue(item: SelectItem) {
        this.$emit('click', item);
        this.isShowHints = false;
    }

    selectDown() {
        //TODO::
        // console.info('keyup down');
    }

    close() {
        this.isShowHints = false;
    }

    created() {
        document.body.addEventListener('click', this.documentClick);
    }
    updated() {
        document.body.addEventListener('click', this.documentClick);
    }
    destroyed() {
        document.body.addEventListener('click', this.documentClick);
    }
}
